import React, { Component } from 'react';
import { CardSubtitle, CardBody } from 'reactstrap';
import AnimatedPopup from 'components/AnimatedPopup';
import { motion } from "framer-motion"
import { IconMore } from 'components/icons'
import { t } from 'i18next';

import {storeActions} from 'stores/storeHelpers'
import developmentLoopService from 'api/developmentLoopService';

export default class DropDownDevloopMenu extends Component {
    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();

        this.state = {
            isMenuOpen: false,
            iscloseDevLoopDialogVisible:false,
            errorMessage:'',
            errorMessageVisible:false
        }

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({
                isMenuOpen: false
            })
        }
    }

    toggle() {
        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        })
    }


    closeDevLoop(){
        console.log('closeDevLoop')

        storeActions.setIsLoading(true)
        developmentLoopService.closeDevelopmentLoop(this.props.developmentLoopId).then(res => {
            this.setState({
                iscloseDevLoopDialogVisible:false
            })

            setTimeout(()=>{
                window.location.reload()
            },1000)
            
        }).catch((err)=>{
            let errorMessage = 'Generic Error'

            try {
                errorMessage = err.response.data
            } catch (error) {
                
            }

            this.setState({
                errorMessage: t(errorMessage),
                errorMessageVisible:true
            })
            storeActions.setIsLoading(false)
        })
        .finally(() => {
            
        })
    
    }

    openAssessment(){
        console.log('openAssessment')

        /*storeActions.setIsLoading(true)
        assessmentService.close(this.props.assessmentId).then(res => {
            this.setState({
                iscloseDevLoopDialogVisible:false
            })
        }).catch(()=>{})
        .finally(() => {
            storeActions.setIsLoading(false)
        })*/
    
    }

    
    togglecloseDevLoopPupoup(){
        this.setState({
            iscloseDevLoopDialogVisible:!this.state.iscloseDevLoopDialogVisible,
            isMenuOpen:false
        })
    }


    render() {
        const subMenuAnimate = {
            enter: {
                opacity: 1,
                translateY: 0,
                transition: {
                    duration: 0.15
                },
                display: "block"
            },
            exit: {
                opacity: 0,
                translateY: -15,
                transition: {
                    duration: 0.15,
                    delay: 0
                },
                transitionEnd: {
                    display: "none"
                }
            }
        };
        const assessmentIsOpen = this.props.open
        return (

            <div className='custom-dropdown' ref={this.wrapperRef}>
                <div onClick={this.toggle.bind(this)} className={"custom-dropdown-handle " + (this.state.isMenuOpen ? 'is-open' : '')}>
                    <IconMore color={this.state.isMenuOpen ? "#ffa61e" : "#fff"} />
                </div>

                {assessmentIsOpen && <motion.div
                    className='custom-dropdown-items-animate'
                    animate={this.state.isMenuOpen ? "enter" : "exit"}
                    variants={subMenuAnimate}
                    initial="exit">
                    <div className="custom-dropdown-items">
                        {assessmentIsOpen && <div className='custom-dropdown-item' onClick={this.togglecloseDevLoopPupoup.bind(this)}>{t('devloop.btnClose')}</div>}
                        {/*!assessmentIsOpen && <div className='custom-dropdown-item' onClick={this.openAssessment.bind(this)}>{t('devloop.btnOpen')}</div>*/}
                    </div>
                </motion.div>}



                

                <AnimatedPopup visible={this.state.iscloseDevLoopDialogVisible} showCloseButton={false}>
                            <CardSubtitle>{t('devloop.popup.title')}</CardSubtitle>

                            <div>
                                <button onClick={this.closeDevLoop.bind(this)} className="btn btn-sm btn-outline-primary mr-2">{t('devloop.popup.btnConfirm')}</button>
                                
                                <button onClick={this.togglecloseDevLoopPupoup.bind(this)} className="btn btn-sm btn-primary">{t('devloop.popup.btnCancel')}</button>
                            </div>

                            {this.state.errorMessageVisible && <div className='mt-2 text-danger'>{this.state.errorMessage}</div>}

                        </AnimatedPopup>

            </div>

        );
    }
}




